module.exports = __webpack_public_path__ + "img/upload-file.fa81e60c.svg";